import { saveAs } from 'file-saver';
import styles from './AttachmentsList.module.css';
import { AiOutlineFilePdf, AiOutlineFileImage, AiOutlineFileWord, AiOutlineFileExcel, AiOutlineFileUnknown } from "react-icons/ai";
import { FiDownload } from "react-icons/fi";
import { GoTrash } from "react-icons/go";
import { api } from "../../../hooks/useApi";
const AttachmentsList = ({ titulo = "ANEXOS", files = [] }) => {

    const getFileIcon = (filename) => {
        const name = filename.toLowerCase();

        if (name.endsWith(".png") || name.endsWith(".jpg")) return <AiOutlineFileImage size={22} color="#4a90e2" />;
        if (name.endsWith(".pdf")) return <AiOutlineFilePdf size={22} color="#e63946" />;
        if (name.endsWith(".doc") || name.endsWith(".docx")) return <AiOutlineFileWord size={22} color="#2a6db0" />;
        if (name.endsWith(".xls") || name.endsWith(".xlsx")) return <AiOutlineFileExcel size={22} color="#207245" />;

        return <AiOutlineFileUnknown size={22} color="#555" />;

    }

    const formatSize = (bytes) => {

        if (bytes < 1024) return `${bytes}B`
        if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)}KB`
        return `${(bytes / 1024 / 1024).toFixed(1)}MB`

    }

    const handleDownload = async (filepath, filename) => {

        const parts = filepath.split('/');
        const arquivo = parts.pop();
        const pasta = parts.pop();

        try {
            const { data } = await api.get(`/Painel/API/DownloadFile/index.php?file=${arquivo}&pasta=${pasta}`, {
                responseType: "blob",
                withCredentials: true
            });
            saveAs(data, filename);

        } catch (e) {
            console.error(e);
        }

    }

    /*const handleDelete = async (id, filepath) => {

        const parts = filepath.split('/');
        const arquivo = parts.pop();
        const pasta = parts.pop();

        try {
            const { data } = await api.delete(`/Painel/API/DeleteFile/index.php?id=${id}&file=${arquivo}&pasta=${pasta}`, {
                withCredentials: true
            });
            console.log(data);
        } catch (e) {
            console.error(e);
        }

    }*/

    return (
        <>
            <p className={styles.titulo} >{titulo}</p>
            <div className={styles.container} >
                {files.map((obj) => (
                    <div className={styles.itemContainer} >
                        <div className={styles.fileIconCont} >
                            <span className={styles.fileIcon} >{getFileIcon(obj.filename)}</span>
                        </div>
                        <div className={styles.fileInfo} >
                            <p><strong>{obj.filename}</strong></p>
                            <p>{formatSize(obj.filesize)}</p>
                        </div>
                        <div className={styles.downloadContainer} >
                            <FiDownload size={22} color='#000'
                                onClick={() => handleDownload(obj.filepath, obj.filename)}
                            />
                        </div>
                        {/*
                            <div className={styles.deleteContainer} >
                                <GoTrash size={22} color="#e63946"
                                    onClick={() => handleDelete(obj.filepath)}
                                />
                            </div>
                        */}
                    </div>
                ))}
            </div>
        </>
    )
}

export default AttachmentsList;